import { Flex } from '@chakra-ui/react';
import { CollapsibleCard } from '@mesh.ai/rabbit';
import useLocalStorageCards from 'Deer/hooks/useLocalStorageCards';
import { setIsCardOpen } from 'Deer/slice/DeerCollapsibleCard.slice';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { checkCollapsibleCardsEnabled, checkNewNavEnabled } from 'utils/helpers/featureFlags';
import { getUniqueCardKey } from 'utils/helpers/getUniqueCardKey';

import { PaperWithShadow } from 'uiToolkitV1/Paper';

import { Loader } from '../../../analytics/commonComponents';
import CFbarChart, { PlotBarChart } from '../../../analytics/continuousFeedback/cfBarChart/CFbarChart';
import { useCFTimelineGraphData } from './hooks/dataHooks';

const endTS = new Date().valueOf();

const graphStartDate = new Date();

graphStartDate.setMonth(graphStartDate.getMonth() - 5);

const startTS = graphStartDate.setHours(0, 0, 0, 0);

const TimelineGraphSection = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const currentURL = history.location.pathname;

  const localStorageKeyForChart = getUniqueCardKey({ url: currentURL, cardId: 'myFeedbackSharedVsReceivedChart' });

  const isChartOpen = useLocalStorageCards({
    localStorageKey: localStorageKeyForChart,
    card: 'myFeedbackSharedVsReceivedChart',
    section: 'myData',
  });

  const { data, isLoading } = useCFTimelineGraphData({
    cohort: null,
    groupByKeys: null,
    splitByKeys: null,
    dateRange: {
      endTS,
      startTS,
    },
  });

  const handleChartChange = (newVal) => {
    dispatch(
      setIsCardOpen({
        card: 'myFeedbackSharedVsReceivedChart',
        section: 'myData',
        isCardOpen: newVal,
        localStorageKey: localStorageKeyForChart,
      })
    );
  };

  return checkCollapsibleCardsEnabled() ? (
    <CollapsibleCard
      style={{
        marginBottom: '8px',
      }}
      title="Feedback shared and received"
      open={isChartOpen}
      onOpenChange={handleChartChange}
      disabled={!checkNewNavEnabled()}
    >
      <Flex h="348px" background="#F5F7F9" borderRadius="8px" p={2}>
        <PaperWithShadow p="8px" borderRadius="8px" flexBasis="100%" w="100%">
          {isLoading ? <Loader /> : <PlotBarChart chartData={data?.data} />}
        </PaperWithShadow>
      </Flex>
    </CollapsibleCard>
  ) : (
    <Flex h="348px" gap={2} mb={3} mt={0}>
      <PaperWithShadow p={4} flexBasis="100%" w="100%">
        {isLoading ? <Loader /> : <CFbarChart chartData={data?.data} />}
      </PaperWithShadow>
    </Flex>
  );
};

export default TimelineGraphSection;
